export const CREDIT_DEBIT_NOTES_RESET_STATE = 'CREDIT_DEBIT_NOTES_RESET_STATE';
export const CREDIT_DEBIT_NOTES_CURRENT_ITEM = 'CREDIT_DEBIT_NOTES_CURRENT_ITEM';
 
export const CREDIT_DEBIT_NOTES_REQUEST_LOADING = 'CREDIT_DEBIT_NOTES_REQUEST_LOADING';
export const CREDIT_DEBIT_NOTES_REQUEST_SUCCESS = 'CREDIT_DEBIT_NOTES_REQUEST_SUCCESS';
export const CREDIT_DEBIT_NOTES_REQUEST_FAILED = 'CREDIT_DEBIT_NOTES_REQUEST_FAILED';
 
export const CREDIT_DEBIT_NOTES_CURRENT_ACTION = 'CREDIT_DEBIT_NOTES_CURRENT_ACTION';
export const CREDIT_DEBIT_NOTES_RESET_ACTION = 'CREDIT_DEBIT_NOTES_RESET_ACTION';